import React from 'react'
import { Control, FieldErrors, UseFormRegister, UseFormWatch } from 'react-hook-form'
import { AppraisalFormProps } from '../../Interface/EmployeeManager/AppraisalForm/AppraisalForm'
import { totalPercentage } from 'Helpers/appraisalRating'
import ApCheckboxOpen from './ApCheckboxOpen'

interface ApTextareaProps {
  register: UseFormRegister<any> // Replace `any` with your form's data type
  errors?: FieldErrors<AppraisalFormProps>
  isManager?: boolean
  isAdmin?: boolean
  isDisabled?: boolean
  watch: UseFormWatch<AppraisalFormProps> | undefined
  control: Control<AppraisalFormProps>
}

const ApStepThreeOpen: React.FC<ApTextareaProps> = ({
  register,
  errors,
  isManager,
  isAdmin,
  isDisabled,
  watch,
  control,
}) => {
  const coreValueTotal = (watch && watch('coreValues')) || []
  const kpiTotal = (watch && watch('kpi')) || []

  const TOTAL_PERCENTAGE = totalPercentage(kpiTotal, coreValueTotal, 'employee_score').toFixed(2)
  const TOTAL_PERCENTAGEMgr = totalPercentage(kpiTotal, coreValueTotal, 'manager_score').toFixed(2)

  const formErrors = (errors: FieldErrors<AppraisalFormProps>, index: number) => {
    return (
      errors?.coreValues && (
        <div className='row d-flex justify-content-end'>
          <div className='col-md-3  text-end'>
            <span className='text-danger'>
              {errors.coreValues[index]?.manager_score &&
                errors.coreValues[index]?.manager_score?.message}

              {errors.coreValues[index]?.employee_score &&
                errors.coreValues[index]?.employee_score?.message}
            </span>
          </div>
        </div>
      )
    )
  }

  return (
    <div>
      <div className='card evaluation px-3 px-md-4 border-0 mt-3 mb-3'>
        <div className='card-header px-0'>Culture Evaluation & Feedback</div>
        <div className='card-body px-0'>
          <div className='row mb-3 heading'>
            {(isManager || isAdmin) && <div className='col-md-6'>Core values (up to 20%)</div>}
            {!(isManager || isAdmin) && <div className='col-md-9'>Core values (up to 20%)</div>}

            {(isManager || isAdmin) && (
              <div className={`${isAdmin === true ? 'col-md-2' : 'col-md-3 text-center'}`}>
                Appraisee Score
              </div>
            )}
            {(isManager || isAdmin) && (
              <div className={`${isAdmin === true ? 'col-md-2' : 'col-md-3 text-center'}`}>
                Line Manager’s Score
              </div>
            )}

            {!(isManager || isAdmin === true) && (
              <div className={`${isAdmin ? 'col-md-2' : 'col-md-3'}`}>Appraisee Score</div>
            )}
          </div>

          <div className='card'>
            <div className='card-header micro-head'>
              <div className='row'>
                <div className='col-md-9 text-dark'> Team Work</div>
                {isAdmin == false && (
                  <>
                    <div className='col-md-1'>Red (0)</div>

                    <div className='col-md-1'>Yellow (1)</div>

                    <div className='col-md-1'>Green (2)</div>
                  </>
                )}
              </div>
            </div>
            <div className='card-body evaluate-body'>
              <div className='row'>
                <div
                  className={
                    isManager || isAdmin
                      ? `${isAdmin === true ? 'col-md-8' : 'col-md-7'}`
                      : 'col-md-9'
                  }
                >
                  You listen to the concerns of co-workers and find solutions/ proffer alternatives
                </div>
                <input
                  type='hidden'
                  {...register('coreValues.0.question')}
                  value=' You listen to the concerns of co-workers and find solutions/
                  proffer alternatives'
                />

                <input type='hidden' {...register('coreValues.0.category')} value={'Team Work'} />

                {(isManager || isAdmin) && (
                  <div className='col-md-2'>
                    <input
                      type='text'
                      {...register('coreValues.0.employee_score')}
                      disabled={isDisabled}
                      className={`form-control ap-select ${
                        errors && errors.coreValues && errors.coreValues[0]?.employee_score
                          ? 'is-invalid'
                          : ''
                      }`}
                    ></input>
                  </div>
                )}

                {isAdmin && (
                  <div className='col-md-2'>
                    <input
                      type='text'
                      {...register('coreValues.0.manager_score')}
                      disabled={isDisabled}
                      className={`form-control ap-select ${
                        errors && errors.coreValues && errors.coreValues[0]?.manager_score
                          ? 'is-invalid'
                          : ''
                      }`}
                    ></input>
                  </div>
                )}

                {isManager && isAdmin === false && (
                  <ApCheckboxOpen
                    name='coreValues.0.manager_score'
                    index={0}
                    register={register}
                    errors={errors}
                    rules={{
                      required: 'Field is required.',
                    }}
                    control={control}
                  ></ApCheckboxOpen>
                )}

                {!isManager && !isAdmin && (
                  <ApCheckboxOpen
                    name='coreValues.0.employee_score'
                    index={0}
                    register={register}
                    errors={errors}
                    rules={{
                      required: 'Field is required.',
                    }}
                    control={control}
                  ></ApCheckboxOpen>
                )}
                {errors?.coreValues && formErrors(errors, 0)}
              </div>

              <div className='row mt-4'>
                <div
                  className={
                    isManager || isAdmin
                      ? `${isAdmin === true ? 'col-md-8' : 'col-md-7'}`
                      : 'col-md-9'
                  }
                >
                  You participate actively on the team, and make yourself available to support your
                  peers and cover effectively in the event of absence
                </div>
                <input
                  type='hidden'
                  {...register('coreValues.1.question')}
                  value='You participate actively on the team, and make yourself
                  available to support your peers and cover effectively in the
                  event of absence'
                />
                <input type='hidden' {...register('coreValues.1.category')} value={'Team Work'} />

                {(isManager || isAdmin) && (
                  <div className='col-md-2'>
                    <input
                      type='text'
                      {...register('coreValues.1.employee_score')}
                      disabled={isDisabled}
                      className={`form-control ap-select ${
                        errors && errors.coreValues && errors.coreValues[1]?.employee_score
                          ? 'is-invalid'
                          : ''
                      }`}
                    ></input>
                  </div>
                )}

                {isAdmin && (
                  <div className='col-md-2'>
                    <input
                      type='text'
                      {...register('coreValues.1.manager_score')}
                      disabled={isDisabled}
                      className={`form-control ap-select ${
                        errors && errors.coreValues && errors.coreValues[1]?.manager_score
                          ? 'is-invalid'
                          : ''
                      }`}
                    ></input>
                  </div>
                )}

                {isManager && isAdmin === false && (
                  <ApCheckboxOpen
                    name='coreValues.1.manager_score'
                    index={1}
                    register={register}
                    errors={errors}
                    rules={{
                      required: 'Field is required.',
                    }}
                    control={control}
                  ></ApCheckboxOpen>
                )}

                {!isManager && !isAdmin && (
                  <ApCheckboxOpen
                    name='coreValues.1.employee_score'
                    index={1}
                    register={register}
                    errors={errors}
                    rules={{
                      required: 'Field is required.',
                    }}
                    control={control}
                  ></ApCheckboxOpen>
                )}
              </div>

              {errors?.coreValues && formErrors(errors, 1)}
            </div>
          </div>

          <div className='card mt-4'>
            <div className='card-header micro-head'>
              <div className='row'>
                <div className='col-md-9 text-dark'> Communication</div>

                {isAdmin == false && (
                  <>
                    <div className='col-md-1'>Red (0)</div>

                    <div className='col-md-1'>Yellow (1)</div>

                    <div className='col-md-1'>Green (2)</div>
                  </>
                )}
              </div>
            </div>
            <div className='card-body evaluate-body'>
              <div className='row'>
                <div
                  className={
                    isManager || isAdmin
                      ? `${isAdmin === true ? 'col-md-8' : 'col-md-7'}`
                      : 'col-md-9'
                  }
                >
                  You actively try to understand the ideas of others and incorporate them where
                  appropriate.
                </div>
                <input
                  type='hidden'
                  {...register('coreValues.2.question')}
                  value='You actively try to understand the ideas of others and
                  incorporate them where'
                />
                <input
                  type='hidden'
                  {...register('coreValues.2.category')}
                  value={'Communication'}
                />

                {(isManager || isAdmin) && (
                  <div className='col-md-2'>
                    <input
                      type='text'
                      {...register('coreValues.2.employee_score')}
                      disabled={isDisabled}
                      className={`form-control ap-select ${
                        errors && errors.coreValues && errors.coreValues[2]?.employee_score
                          ? 'is-invalid'
                          : ''
                      }`}
                    ></input>
                  </div>
                )}

                {isManager && isAdmin === false && (
                  <ApCheckboxOpen
                    name='coreValues.2.manager_score'
                    index={2}
                    register={register}
                    errors={errors}
                    rules={{
                      required: 'Field is required.',
                    }}
                    control={control}
                  ></ApCheckboxOpen>
                )}

                {isAdmin && (
                  <div className='col-md-2'>
                    <input
                      type='text'
                      {...register('coreValues.2.manager_score')}
                      disabled={isDisabled}
                      className={`form-control ap-select ${
                        errors && errors.coreValues && errors.coreValues[2]?.manager_score
                          ? 'is-invalid'
                          : ''
                      }`}
                    ></input>
                  </div>
                )}

                {!isManager && isAdmin === false && (
                  <ApCheckboxOpen
                    name='coreValues.2.employee_score'
                    index={2}
                    register={register}
                    errors={errors}
                    rules={{
                      required: 'Field is required.',
                    }}
                    control={control}
                  ></ApCheckboxOpen>
                )}

                {errors?.coreValues && formErrors(errors, 2)}
              </div>

              <div className='row mt-4'>
                <div
                  className={
                    isManager || isAdmin
                      ? `${isAdmin === true ? 'col-md-8' : 'col-md-7'}`
                      : 'col-md-9'
                  }
                >
                  You articulate ideas and suggestions clearly
                </div>
                <input
                  type='hidden'
                  {...register('coreValues.3.question')}
                  value=' Appropriate and if not provide explanation why'
                />
                <input
                  type='hidden'
                  {...register('coreValues.3.category')}
                  value={'Communication'}
                />

                {(isManager || isAdmin) && (
                  <div className='col-md-2'>
                    <input
                      type='text'
                      {...register('coreValues.3.employee_score')}
                      disabled={isDisabled}
                      className={`form-control ap-select ${
                        errors && errors.coreValues && errors.coreValues[3]?.employee_score
                          ? 'is-invalid'
                          : ''
                      }`}
                    ></input>
                  </div>
                )}

                {isManager && (
                  <ApCheckboxOpen
                    name='coreValues.3.manager_score'
                    index={3}
                    register={register}
                    errors={errors}
                    rules={{
                      required: 'Field is required.',
                    }}
                    control={control}
                  ></ApCheckboxOpen>
                )}
                {isAdmin && (
                  <div className='col-md-2'>
                    <input
                      type='text'
                      {...register('coreValues.3.manager_score')}
                      disabled={isDisabled}
                      className={`form-control ap-select ${
                        errors && errors.coreValues && errors.coreValues[3]?.manager_score
                          ? 'is-invalid'
                          : ''
                      }`}
                    ></input>
                  </div>
                )}

                {!isManager && isAdmin === false && (
                  <ApCheckboxOpen
                    name='coreValues.3.employee_score'
                    index={3}
                    register={register}
                    errors={errors}
                    rules={{
                      required: 'Field is required.',
                    }}
                    control={control}
                  ></ApCheckboxOpen>
                )}
              </div>

              {errors?.coreValues && formErrors(errors, 3)}
            </div>
          </div>

          <div className='card mt-4'>
            <div className='card-header micro-head'>
              <div className='row'>
                <div className='col-md-9 text-dark'>Innovation & Leadership</div>

                {isAdmin == false && (
                  <>
                    <div className='col-md-1'>Red (0)</div>

                    <div className='col-md-1'>Yellow (1)</div>

                    <div className='col-md-1'>Green (2)</div>
                  </>
                )}
              </div>
            </div>
            <div className='card-body evaluate-body'>
              <div className='row'>
                <div
                  className={
                    isManager || isAdmin
                      ? `${isAdmin === true ? 'col-md-8' : 'col-md-7'}`
                      : 'col-md-9'
                  }
                >
                  You motivate self and others to achieve set goals
                </div>
                <input
                  type='hidden'
                  {...register('coreValues.4.question')}
                  value='You motivate self and others to achieve set goals'
                />
                <input
                  type='hidden'
                  {...register('coreValues.4.category')}
                  value={'Innovation & Leadership'}
                />

                {(isManager || isAdmin) && (
                  <div className='col-md-2'>
                    <input
                      type='text'
                      {...register('coreValues.4.employee_score')}
                      disabled={isDisabled}
                      className={`form-control ap-select ${
                        errors && errors.coreValues && errors.coreValues[4]?.employee_score
                          ? 'is-invalid'
                          : ''
                      }`}
                    ></input>
                  </div>
                )}

                {isManager && isAdmin === false && (
                  <ApCheckboxOpen
                    name='coreValues.4.manager_score'
                    index={4}
                    register={register}
                    errors={errors}
                    rules={{
                      required: 'Field is required.',
                    }}
                    control={control}
                  ></ApCheckboxOpen>
                )}

                {isAdmin && (
                  <div className='col-md-2'>
                    <input
                      type='text'
                      {...register('coreValues.4.manager_score')}
                      disabled={isDisabled}
                      className={`form-control ap-select ${
                        errors && errors.coreValues && errors.coreValues[4]?.manager_score
                          ? 'is-invalid'
                          : ''
                      }`}
                    ></input>
                  </div>
                )}

                {!isManager && isAdmin === false && (
                  <ApCheckboxOpen
                    name='coreValues.4.employee_score'
                    index={4}
                    register={register}
                    errors={errors}
                    rules={{
                      required: 'Field is required.',
                    }}
                    control={control}
                  ></ApCheckboxOpen>
                )}
              </div>
              {errors?.coreValues && formErrors(errors, 4)}

              <div className='row mt-4'>
                <div
                  className={
                    isManager || isAdmin
                      ? `${isAdmin === true ? 'col-md-8' : 'col-md-7'}`
                      : 'col-md-9'
                  }
                >
                  You can run with an idea with little or no supervision
                </div>
                <input
                  type='hidden'
                  {...register('coreValues.5.question')}
                  value='You can run with an idea with little or no supervision'
                />
                <input
                  type='hidden'
                  {...register('coreValues.5.category')}
                  value={'Innovation & Leadership'}
                />
                {(isManager === true || isAdmin === true) && (
                  <div className='col-md-2'>
                    <input
                      type='text'
                      {...register('coreValues.5.employee_score')}
                      disabled={isDisabled}
                      className={`form-control ap-select ${
                        errors && errors.coreValues && errors.coreValues[5]?.employee_score
                          ? 'is-invalid'
                          : ''
                      }`}
                    ></input>
                  </div>
                )}
                {isManager === true && isAdmin === false && (
                  <>
                    <ApCheckboxOpen
                      name='coreValues.5.manager_score'
                      index={5}
                      register={register}
                      errors={errors}
                      rules={{
                        required: 'Field is required.',
                      }}
                      control={control}
                    ></ApCheckboxOpen>
                  </>
                )}

                {isAdmin === true && (
                  <div className='col-md-2'>
                    <input
                      type='text'
                      {...register('coreValues.5.manager_score')}
                      disabled={isDisabled}
                      className={`form-control ap-select ${
                        errors && errors.coreValues && errors.coreValues[5]?.manager_score
                          ? 'is-invalid'
                          : ''
                      }`}
                    ></input>
                  </div>
                )}

                {!isManager && isAdmin == false && (
                  <ApCheckboxOpen
                    name='coreValues.5.employee_score'
                    index={5}
                    register={register}
                    errors={errors}
                    rules={{
                      required: 'Field is required.',
                    }}
                    control={control}
                  ></ApCheckboxOpen>
                )}
              </div>

              {errors?.coreValues && formErrors(errors, 5)}
            </div>
          </div>

          <div className='card mt-4'>
            <div className='card-header micro-head'>
              <div className='row'>
                <div className='col-md-9 text-dark'> Time management</div>
                {isAdmin == false && (
                  <>
                    <div className='col-md-1'>Red (0)</div>

                    <div className='col-md-1'>Yellow (1)</div>

                    <div className='col-md-1'>Green (2)</div>
                  </>
                )}
              </div>
            </div>
            <div className='card-body evaluate-body'>
              <div className='row'>
                <div
                  className={
                    isManager || isAdmin
                      ? `${isAdmin === true ? 'col-md-8' : 'col-md-7'}`
                      : 'col-md-9'
                  }
                >
                  You are on time to physical and virtual meetings
                </div>
                <input
                  type='hidden'
                  {...register('coreValues.6.question')}
                  value='You are on time to physical and virtual meetings'
                />
                <input
                  type='hidden'
                  {...register('coreValues.6.category')}
                  value={'Time management'}
                />

                {(isManager || isAdmin) && (
                  <div className='col-md-2'>
                    <input
                      type='text'
                      {...register('coreValues.6.employee_score')}
                      disabled={isDisabled}
                      className={`form-control ap-select ${
                        errors && errors.coreValues && errors.coreValues[6]?.employee_score
                          ? 'is-invalid'
                          : ''
                      }`}
                    ></input>
                  </div>
                )}
                {isManager && isAdmin === false && (
                  <ApCheckboxOpen
                    name='coreValues.6.manager_score'
                    index={6}
                    register={register}
                    errors={errors}
                    rules={{
                      required: 'Field is required.',
                    }}
                    control={control}
                  ></ApCheckboxOpen>
                )}

                {isAdmin && (
                  <div className='col-md-2'>
                    <input
                      type='text'
                      {...register('coreValues.6.manager_score')}
                      disabled={isDisabled}
                      className={`form-control ap-select ${
                        errors && errors.coreValues && errors.coreValues[6]?.manager_score
                          ? 'is-invalid'
                          : ''
                      }`}
                    ></input>
                  </div>
                )}

                {!isManager && isAdmin === false && (
                  <ApCheckboxOpen
                    name='coreValues.6.employee_score'
                    index={6}
                    register={register}
                    errors={errors}
                    rules={{
                      required: 'Field is required.',
                    }}
                    control={control}
                  ></ApCheckboxOpen>
                )}
              </div>

              {errors?.coreValues && formErrors(errors, 6)}

              <div className='row mt-4'>
                <div
                  className={
                    isManager || isAdmin
                      ? `${isAdmin === true ? 'col-md-8' : 'col-md-7'}`
                      : 'col-md-9'
                  }
                >
                  You meet deadlines on all tasks and if the need to extend deadlines arises you
                  communicate ahead as against being prompted.
                </div>
                <input
                  type='hidden'
                  {...register('coreValues.7.question')}
                  value='You meet deadlines on all tasks and if the need to extend
                  deadlines arises you communicate ahead as against being
                  prompted.'
                />
                <input
                  type='hidden'
                  {...register('coreValues.7.category')}
                  value={'Time management'}
                />

                {(isManager || isAdmin) && (
                  <div className='col-md-2'>
                    <input
                      type='text'
                      {...register('coreValues.7.employee_score')}
                      disabled={isDisabled}
                      className={`form-control ap-select ${
                        errors && errors.coreValues && errors.coreValues[7]?.employee_score
                          ? 'is-invalid'
                          : ''
                      }`}
                    ></input>
                  </div>
                )}

                {isManager && isAdmin === false && (
                  <ApCheckboxOpen
                    name='coreValues.7.manager_score'
                    index={7}
                    register={register}
                    errors={errors}
                    rules={{
                      required: 'Field is required.',
                    }}
                    control={control}
                  ></ApCheckboxOpen>
                )}
                {isAdmin && (
                  <div className='col-md-2'>
                    <input
                      type='text'
                      {...register('coreValues.7.manager_score')}
                      disabled={isDisabled}
                      className={`form-control ap-select ${
                        errors && errors.coreValues && errors.coreValues[7]?.manager_score
                          ? 'is-invalid'
                          : ''
                      }`}
                    ></input>
                  </div>
                )}

                {!isManager && isAdmin === false && (
                  <ApCheckboxOpen
                    name='coreValues.7.employee_score'
                    index={7}
                    register={register}
                    errors={errors}
                    rules={{
                      required: 'Field is required.',
                    }}
                    control={control}
                  ></ApCheckboxOpen>
                )}
              </div>
              {errors?.coreValues && formErrors(errors, 7)}

              <div className='row mt-4'>
                <div
                  className={
                    isManager || isAdmin
                      ? `${isAdmin === true ? 'col-md-8' : 'col-md-7'}`
                      : 'col-md-9'
                  }
                >
                  You manage stress to stay motivated.
                </div>
                <input
                  type='hidden'
                  {...register('coreValues.8.question')}
                  value='You manage stress to stay motivated.'
                />
                <input type='hidden' {...register('coreValues.8.category')} value={'Team Work'} />

                {(isManager || isAdmin) && (
                  <div className='col-md-2'>
                    <input
                      type='text'
                      {...register('coreValues.8.employee_score')}
                      disabled={isDisabled}
                      className={`form-control ap-select ${
                        errors && errors.coreValues && errors.coreValues[8]?.employee_score
                          ? 'is-invalid'
                          : ''
                      }`}
                    ></input>
                  </div>
                )}
                {isManager && isAdmin === false && (
                  <ApCheckboxOpen
                    name='coreValues.8.manager_score'
                    index={8}
                    register={register}
                    errors={errors}
                    rules={{
                      required: 'Field is required.',
                    }}
                    control={control}
                  ></ApCheckboxOpen>
                )}

                {isAdmin && (
                  <div className='col-md-2'>
                    <input
                      type='text'
                      {...register('coreValues.8.manager_score')}
                      disabled={isDisabled}
                      className={`form-control ap-select ${
                        errors && errors.coreValues && errors.coreValues[8]?.manager_score
                          ? 'is-invalid'
                          : ''
                      }`}
                    ></input>
                  </div>
                )}

                {!isManager && isAdmin === false && (
                  <ApCheckboxOpen
                    name='coreValues.8.employee_score'
                    index={8}
                    register={register}
                    errors={errors}
                    rules={{
                      required: 'Field is required.',
                    }}
                    control={control}
                  ></ApCheckboxOpen>
                )}
              </div>

              {errors?.coreValues && formErrors(errors, 8)}
            </div>
          </div>

          <div className='card mt-4 pb-0 mb-0 '>
            <div className='card-body evaluate-body'>
              <div className='row  virtual-meetings'>
                <div className={isManager || isAdmin ? 'col-6' : 'col-9'}>
                  TOTAL APPRAISAL SCORES
                </div>

                {(isManager || isAdmin) && (
                  <>
                    <div className='col-3 text-center'>Employee: {TOTAL_PERCENTAGE}% / 100%</div>
                    <div className='col-3 text-center'>
                      Line Manager: {TOTAL_PERCENTAGEMgr}% / 100%
                    </div>
                  </>
                )}
                {!isManager && isAdmin === false && (
                  <div className='col-3'> {TOTAL_PERCENTAGE}% / 100%</div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ApStepThreeOpen
